module.exports = __webpack_public_path__ + "img/profile_teo_ft0.5d0f612b.jpg";